export default "__VITE_ASSET__6a500dae__"